import { render, staticRenderFns } from "./approve-detail-sign.html?vue&type=template&id=9ad460ae&"
import script from "./approve-detail-sign.ts?vue&type=script&lang=ts&"
export * from "./approve-detail-sign.ts?vue&type=script&lang=ts&"
import style0 from "./approve-detail-sign.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports